export const hpbtoa = (str) => {
				return btoa(String(str || "").split("").map(c => c.charCodeAt(0)).join(","));	
			};
export const hpatob = (strb64) => {
				return atob(strb64 || "").split(",").map(ccode => String.fromCharCode(ccode)).join("");
			};			

export const addChecksum27 = (str) =>  {
  let sum = 0;
  str = String(str); 
  for (let i = 0; i < str.length; i++) {
    sum += str.charCodeAt(i);
  }
  const checksum = String(sum % 27).padStart(2, '0');
  return str + checksum;
};

export const verifiedChecksum27 = (strWithChecksum) => {
  strWithChecksum = String(strWithChecksum); // Ensure input is a string
  if (strWithChecksum.length < 2) {
    return false;
  }
  const originalStr = strWithChecksum.slice(0, -2);
  const appendedChecksum = strWithChecksum.slice(-2);
  let sum = 0;
  for (let i = 0; i < originalStr.length; i++) {
    sum += originalStr.charCodeAt(i);
  }
  const calculatedChecksum = String(sum % 27).padStart(2, '0');
  return calculatedChecksum === appendedChecksum ? originalStr : false;
};

export const validateEmail = (email) => {
	  return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(String(email).toLowerCase());
};

const uint8ToBase64 = (uint8Array) => {
  let binaryString = '';
  uint8Array.forEach(byte => {
	binaryString += String.fromCharCode(byte);
  });
  return btoa(binaryString);
};

const base64ToUint8 = (base64String) => {
  const binaryString = atob(base64String);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
	bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
};

export const encodeDataWithKey = (dataString, key) => {
  const encoder = new TextEncoder();
  const dataBytes = encoder.encode(dataString); // UTF-8 bytes of data
  const keyBytes = encoder.encode(key); // UTF-8 bytes of key

  const xoredBytes = new Uint8Array(dataBytes.length);
  for (let i = 0; i < dataBytes.length; i++) {
	xoredBytes[i] = dataBytes[i] ^ keyBytes[i % keyBytes.length];
  }
  return uint8ToBase64(xoredBytes); // Base64 encode the resulting bytes
};

export const decodeDataWithKey = (encodedDataString, key) => {
  const xoredBytes = base64ToUint8(encodedDataString); // Decode Base64 to bytes
  const encoder = new TextEncoder();
  const keyBytes = encoder.encode(key); // UTF-8 bytes of key

  const decodedBytes = new Uint8Array(xoredBytes.length);
  for (let i = 0; i < xoredBytes.length; i++) {
	decodedBytes[i] = xoredBytes[i] ^ keyBytes[i % keyBytes.length];
  }
  const decoder = new TextDecoder('utf-8');
  return decoder.decode(decodedBytes); // Decode resulting bytes back to string
};

export const toJsonObjectString = (obj, defaultVal) => {
	if(!obj){
		if(defaultVal !== undefined)
			return defaultVal;
		return "{}";
	}
	
	if (typeof obj === 'string' || obj instanceof String){
		let tstr = String(obj).trim();
		if(/^\{|^\[/.test(tstr) && /\}$|\]$/.test(tstr)){
			return tstr;	
		}else{
			if(defaultVal !== undefined)
				return defaultVal;
			return "{}";
		}
	}
	
	try{
		return JSON.stringify(obj);
	}catch(ex){
		if(defaultVal !== undefined)
			return defaultVal;
		return "{}";
	}
}

export const jsonObjectFromString = (str, defaultVal) => {
	if(!str){
		if(defaultVal !== undefined)
			return defaultVal;
		return {};
	}
	
	if(typeof str === 'object')
		return str;
	
	if (!(typeof str === 'string' || str instanceof String)){
	  return str;
    }
	
	try{
		return JSON.parse(str);
	}catch(ex){
		if(defaultVal !== undefined)
			return defaultVal;
		return {};
	}
}

export const json_string_if_object = toJsonObjectString;
export const object_if_json_string = jsonObjectFromString;

export const toObjectOrStringFromValue = (obj, defaultVal) => {
	if(!obj){
		if(defaultVal !== undefined)
			return defaultVal;
		return "";
	}
	
	if(typeof obj === 'object')
		return obj;
	
	if (typeof obj === 'string' || obj instanceof String){
	    try{
		  	if(/^\{|^\[/.test("" + obj) && /\}$|\]$/.test("" + obj)){
				return JSON.parse(obj);	
			}
		}catch(ex){
			//
		}
    }
	return String(obj);
}

export const roundWithPrecision = (num, precision) => {
	let exponent = Math.pow(10,precision || 0);
	return Math.round((parseFloat(num) || 0.0) * exponent)/exponent; 
};

export const round2 = (num) => {
	return Math.round((parseFloat(num) || 0.0) * 100)/100; 
};

export const prepareObjectForUse = (obj, full) => {
	
	if(obj && obj.toJSON){
		obj = obj.toJSON();
	}
	
	if(obj){
		Object.keys(obj).filter(k => /^Data$|[a-z]Data$/.test(k) && obj[k]).forEach(k=> {
			obj[k] = jsonObjectFromString(obj[k]);
		});
	}
	
	if(obj && full){
		Object.keys(obj).filter(k => /^Subscription$|^Order$/.test(k) && obj[k]).forEach(k=> {
			obj[k] = prepareObjectForUse(obj[k], full);
		});
		
		Object.keys(obj).filter(k => /^Orders$|^Transactions$/.test(k) && obj[k]).forEach(k=> {
			if(obj[k] && obj[k].length){
				obj[k] = obj[k].map(item => prepareObjectForUse(item, full));
			}
		});
	}
	
	return obj;
};
  
export const prepareObjectForStorage = (obj) => {
	Object.keys(obj).filter(k => /^Data$|[a-z]Data$/.test(k) && obj[k]).forEach(k=> {
		obj[k] = json_string_if_object(obj[k]);
	});
	return obj;
}  

export const dateWithDayOffset = (date, offset_days) => {
	let d = new Date(date);
    d.setDate(d.getDate() + (parseInt(offset_days) || 0));
	return d.toISOString().substring(0,16).replace("T"," ");	
};

const definition = {
	hpbtoa,
    hpatob,
	addChecksum27,
	verifiedChecksum27,
	validateEmail,
	encodeDataWithKey,
	decodeDataWithKey,
	toJsonObjectString,
	toObjectOrStringFromValue,
	json_string_if_object,
	object_if_json_string,
	roundWithPrecision,
	round2,
	prepareObjectForUse,
	prepareObjectForStorage,
	dateWithDayOffset
};

export default definition;